import React from "react";

import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import {
  closePopup,
  getPopupRegistration,
  openPopup,
  Priority,
} from "app/PopupHolder";

import { useToast } from '../../components/ToastMessage/ToastManager';
import SimpleModal from "../../../components/base/SimpleModal";
import LoanGeekFullLogo from "../../../assets/images/loan-geek-full-logo.svg";
import { apiService_be, LOAN_GEEK_URL } from "../../../utils/Api";
import { selectUserId } from '../../../data/user';


import css from "./style.scss";

const TERMS_LINK = "https://loangeek.com/terms-and-conditions/"
const PRIVACY_LINK = "https://privacy.cptn.co/privacy-policy/d3e4dc90-832b-49cf-a2aa-773fdb8d0824"

// Renders LoanGeek modal
const LoanGeekModal = ({ closePopup, propertyId }) => {
  const showToast = useToast();
  const userId = useSelector(selectUserId);  
  const [loading, setLoading] = React.useState(false);
  const handleContinue = async () => {
    try{
        setLoading(true)
        const response = await apiService_be.post(LOAN_GEEK_URL, { userId, propertyId });
        if(response?.data?.url || response?.data?.fallbackUrl){
          const newWindow = window.open(response?.data?.url || response?.data?.fallbackUrl, "_blank", "noopener,noreferrer");
          if (newWindow) {
            newWindow.opener = null;
          }
          closePopup();
        }
        else {
          showToast("Something went wrong. Please try again.", "error");
        }
    }
    catch(e){
        showToast(e.message || "Something went wrong. Please try again.", "error");
    }
    finally{
        setLoading(false);   
    }
  };
  const handleClose = () => {
    if (loading) return;
    closePopup();
  };
  return (
    <SimpleModal
      uniqueId="loanGeekModal"
      ignoreEscAndClickOutside={loading}
      loading={loading}
      modalClassName={css.loanGeekModal}
      onCancel={handleClose}
      onSubmit={handleContinue}
      modalBody={
        <div className={css.loanGeekModalBody}>
          <img src={LoanGeekFullLogo} className={css.loanGeekLogo} />
          <p className={css.title}>Continue to LoanGeek?</p>
          <p className={css.description}>
            LoanGeek offers fast, transparent financing options for real estate
            investments. By selecting Continue, you will be redirected to an
            application operated by LoanGeek and authorize us to disclose your
            contact information to them. By proceeding, you acknowledge and
            agree that your information and activity will be governed by
            LoanGeek’s 
            <a href={PRIVACY_LINK} target="_blank" className={css.link}>
               privacy notice 
            </a> 
            and 
            <a href={TERMS_LINK} target="_blank" className={css.link}>
               terms and conditions 
            </a> 
            for the services they provide you.
          </p>
        </div>
      }
      modalFooterWrapperClassName={css.loanGeekModalFooter}
      cancelText={"Maybe Later"}
      submitText={"Continue"}
      modalSubmitBtnClassName={css.continueBtn}
      modalCancelBtnClassName={css.cancelBtn}
    />
  );
};

export default LoanGeekModal;

const registrationId = getPopupRegistration(LoanGeekModal);

LoanGeekModal.open = (props = {}) =>
  openPopup(registrationId, { ...props, priority: Priority.HIGHEST });
LoanGeekModal.close = () => closePopup({ popup: registrationId });

LoanGeekModal.propTypes = {
  closePopup: PropTypes.func.isRequired,
  propertyId: PropTypes.string.isRequired,
};
